/**
 * Takes in bytes and converts it to the appropriate conversion
 * @param bytes - number of bytes
 * @param decimals - decimal place, default 2
 * @returns string EG '2.00KB'
 */
export function formatBytes(bytes: number, decimals = 2) {
	if (!bytes) {
		return '0 B';
	}

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'AB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
